"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLogger = exports.logger = void 0;
const TempLogger = {
    extend: () => TempLogger,
    setContextValue: () => { },
    removeContextValue: () => { },
    trace: (...args) => {
        console.warn('[sdk-core] logger called before Streem.configure()');
        console.trace(...args);
    },
    isTrace: () => true,
    debug: (...args) => {
        console.warn('[sdk-core] logger called before Streem.configure()');
        console.debug(...args);
    },
    isDebug: () => true,
    info: (...args) => {
        console.warn('[sdk-core] logger called before Streem.configure()');
        console.info(...args);
    },
    isInfo: () => true,
    warn: (...args) => {
        console.warn('[sdk-core] logger called before Streem.configure()');
        console.warn(...args);
    },
    isWarn: () => true,
    error: (...args) => {
        console.warn('[sdk-core] logger called before Streem.configure()');
        console.error(...args);
    },
    isError: () => true,
};
exports.logger = TempLogger;
function setLogger(nextLogger) {
    exports.logger = nextLogger;
}
exports.setLogger = setLogger;
//# sourceMappingURL=logger.js.map